import useEventListenerOutside from './useEventListenerOutside';
var useOnClickOutside = function useOnClickOutside(handler, refs) {
  useEventListenerOutside(handler, 'mousedown', refs);
  useEventListenerOutside(handler, 'touchstart', refs);
};
export default useOnClickOutside;